import React, { useEffect } from "react";
import Footer from "../components/Footer";
import NavigationBar from "../components/NavigationBar";
import { Outlet } from "react-router-dom";
import FloatNav from "../components/FloatNav";
import BackToTop from "../components/BackToTop";
import OpenRekening from "../components/OpenRekening";
import { GrowthBook, GrowthBookProvider } from "@growthbook/growthbook-react";

const growthbook = new GrowthBook({
  apiHost: "https://cdn.growthbook.io",
  clientKey: process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: true,
  trackingCallback: (experiment, result) => {
  }
});
const Layout = () => {
  useEffect(() => {
    growthbook.init({ streaming: true });
  }, []);
  return (
    <div className="bg-wave">
      <NavigationBar />
      <Outlet />
      <Footer />
      <FloatNav />
      <BackToTop />
      <GrowthBookProvider growthbook={growthbook}>
        <OpenRekening />
      </GrowthBookProvider>
    </div>
  );
};

export default Layout;
